import { Location } from '../../../clients/quipli-service/location/location';
import { CollapsibleRef } from '../../../components/collapsible/collapsible';

export function handleLocationSelection(location: Location | null, collapsibleRefs: Record<number, CollapsibleRef>) {
  if (location) {
    // Close all other collapsibles first
    Object.keys(collapsibleRefs).forEach((locationId) => {
      const numLocationId = parseInt(locationId);
      if (numLocationId !== location.id && collapsibleRefs[numLocationId]) {
        collapsibleRefs[numLocationId]?.toggle(false);
      }
    });

    // Toggle the selected location's collapsible
    if (collapsibleRefs[location.id]) {
      collapsibleRefs[location.id]?.toggle(true);

      // Scroll to the collapsible content after a short delay to allow animation
      setTimeout(() => {
        collapsibleRefs[location.id]?.scrollToContent();
      }, 100);
    }
  }
}
